<template>
  <div class="database-list-item" @click="handleGoto(item)">
    <div class="database-list-img">
      <img :src="item.coverMaterialUrl ? item.coverMaterialUrl : ''" alt="" class="cover-img"/>
      <img class="courseType-img"
           :src="item.courseType == 1 ? require('../../../assets/images/data-base/compulsory.png') : require('../../../assets/images/data-base/take.png')"/>
    </div>
    <div class="database-list-info">
      <div class="item-title">
        <span>{{ item && item.name }}</span>
      </div>
      <div class="item-txt">
        播放量：{{ item && item.playNum }}
      </div>
      <div class="item-teacher" v-if="titleActive == '1'">
        医院：{{ item.lecturerHospitals ? item.lecturerHospitals : '' }}
      </div>
      <div>
        <div class="item-teacher">
          讲师：{{ item.courseLecturers ? item.courseLecturers : '无' }}
        </div>
        <div class="item-coursestate" :class="`${item.isUnlock}` === '1' && !item.myUnlock ? 'unlock' : ''"
             v-if="titleActive == '1'">
          <span class="blue" v-if="item.learningStatus == 2">● 进行中</span>
          <span class="green" v-else-if="item.learningStatus == 1">● 已完成</span>
          <span v-else>● 未开始</span>
        </div>
      </div>
      <div class="item-unlock" v-if="`${item.isUnlock}` === '1' && !item.myUnlock">
        <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
        <span class="txt">{{ item && item.unlockCost }}积分解锁</span>
      </div>
    </div>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleGotoDetails" :dataProps="dataProps"></dialog-unlock>
  </div>
</template>

<script>
import dialogUnlock from '../../../components/dialogUnlock.vue'
import {isScorm} from '../../../api/scorm'

export default {
  name: 'database-list-item',
  components: {
    'dialog-unlock': dialogUnlock
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: ''
        }
      }
    },
    titleActive: {
      type: String,
      default: '1'
    },
    courseCategoryIdFirst: {
      type: String,
      default: ''
    },
    courseCategoryIdSecond: {
      type: String,
      default: ''
    },
    courseCategoryIdThird: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      key: '',
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
    }
  },
  methods: {
    handleGoto(item) {
      this.courseId = item.id
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.id
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleGotoDetails()
    },
    async handleGotoDetails() {
      const query = {
        courseId: this.courseId,
        businessId: this.courseCategoryIdThird || this.courseCategoryIdSecond || this.courseCategoryIdFirst,
        entrance: '11',
        channel: '11'
      }
      const isscorm = await isScorm(this.courseId)
      let path = '/courserDetails'
      if (isscorm.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({path, query})
    },
  }
}
</script>

<style lang="less" scoped>
.database-list-item {
  background: #ffffff;
  padding: 10px 10px 6px 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  .database-list-img {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .cover-img {
      height: 130px;
      width: 100%;
      border-radius: 10px;
    }

    .courseType-img {
      position: absolute;
      right: 0;
      top: 0;
      width: 28px;
    }
  }

  .database-list-info {

    & > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .item-txt {
      font-size: 10px;
      color: #B8B8B8;
      font-weight: 500;
      margin-bottom: 4px;
    }

    .item-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #2B2B2B;
      margin-bottom: 4px;
    }

    .item-teacher {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #5B5F6A;
      margin-bottom: 4px;
    }

    .item-unlock {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 2px;

      .icon-unlock {
        width: 10px;
        margin-right: 4px;
        display: block;
      }

      .txt {
        color: #EB1700;
        font-size: 10px;
      }
    }
  }

  .item-coursestate {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #999999;

    .blue {
      color: #00a2ff;
    }

    .green {
      color: #38c976;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/database/modules/DatabaseListItem.vue